import { lazy, Suspense } from 'react';
import { ImageComparerProps } from './interfaces';

const ImageComparerComponent = lazy(() =>
  import('./ImageComparer').then((mod) => ({ default: mod.ImageComparer }))
);

function ImageComparerFallback() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1e1e1e',
        borderRadius: '4px',
        color: '#fff',
      }}
    >
      <div>
        <div className="spinner-border text-light mb-2" role="status">
          <span className="visually-hidden">Loading viewer...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading image comparer...</div>
      </div>
    </div>
  );
}

export function ImageComparerLazy(props: ImageComparerProps) {
  return (
    <Suspense fallback={<ImageComparerFallback />}>
      <ImageComparerComponent {...props} />
    </Suspense>
  );
}

export default ImageComparerLazy;
